<script>
  import { onMount, onDestroy, tick, afterUpdate } from 'svelte';
  import Comments from '@app-components/comments/Comments.svelte';
  import jQuery from 'jquery';
  import ListCommentsHeader from './ListCommentsHeader.svelte';
  import Modal from '@components/Modal.svelte';
  import CustomScroll from '@utils/custom-scroll';
  import AddComment from '@app-components/comments/AddComment.svelte';

  export let commentId = null;
  export let showModal = false;
  export let customGroupStore;

  let group = customGroupStore;
  let unsubGroup = group.subscribe((x) => (group = x));
  let focused = commentId == null;
  let commentContainer;
  let commentOuterContainer;
  let isFixed = false; // State to control the positioning of AddComment
  $: commentContainerHeight = 0;

  $: total = (group && group.comments && group.comments.total) || 0;
  let isCommentEditMode = false;
  let addCommentKey = 0;

  let handleOverlayClick = function () {
    addCommentKey += 1;
  };

  let calculateHeight = function () {
    if (commentContainer && commentOuterContainer) {
      commentContainerHeight = commentContainer.clientHeight;
      isFixed = commentOuterContainer.clientHeight <= commentContainer.clientHeight + 45;
    }
  };
  $: {
    calculateHeight();
  }

  var scrollToBottom = async function () {
    await tick();
    jQuery('.group-comments-container').scrollTop(9999999);
  };

  onDestroy(() => {
    unsubGroup();
  });

  onMount(() => {
    if (commentId) {
      setTimeout(CustomScroll.scrollToRequiredDivById, 200, `comment-box-${commentId}`);
      commentId = null;
    } else {
      setTimeout(scrollToBottom, 100);
    }
  });

  afterUpdate(() => {
    calculateHeight();
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
  * :global(.modal__container) {
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    height: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
  }
  * :global(.modal__overlay.not-edit-comment-mode) {
    background: rgba(0, 0, 0, 0.07) !important;
  }
  * :global(.modal__content) {
    margin-top: 0px !important;
  }
  .group-comments-container {
    position: fixed;
    background: var(--neutral-white, #fff);
    // z-index: 21;
    right: 0;
    top: 0;
    height: 100%;
    width: 510px;
    padding: 32px;
    padding-bottom: 0px;
    padding-right: 0px;
    .comments-listing-container {
      padding-right: 32px;
      padding-bottom: 45px;
      height: calc(100dvh - 140px);
      :global(.add-comment-no-reply) {
        border-radius: 8px !important;
        border: 1px solid var(--neutral-input-gray, #ececec) !important;
        background: var(--neutral-white, #fff) !important;
      }
      &.focused {
        :global(.add-comment-no-reply) {
          border: 1px solid #896bd9 !important;
          background: #f5f3fc !important;
        }
      }
    }
  }
  * :global(.comment-input) {
    width: 100% !important;
  }
  .fixed-add-comment {
    background: white;
    position: fixed;
    bottom: 0;
    z-index: 5;
    padding-top: 15px;
    width: 100%; /* Adjust width as necessary */

    &__shadow {
      position: absolute;
      top: 0;
      left: -35px;
      right: 0;
      bottom: 0;
      box-shadow: 0px -4px 28px 0px rgba(0, 0, 0, 0.08);
      clip-path: inset(-28px 0px 0px 0px);
      z-index: -1;
    }
  }
  .add-unfixed-comment-container {
    margin-top: 15px;
    z-index: 5;
    position: relative;
    margin-left: -42px;
    padding-left: 32px;
    margin-right: -42px;
    padding-right: 32px;
    background: white;
  }
</style>

{#if showModal}
  <div class="svelte-modal">
    <Modal
      mobile={false}
      on:close={() => {
        showModal = false;
      }}
      overlayClass={isCommentEditMode ? '' : 'not-edit-comment-mode'}
      show={showModal}
      showCloseButton={false}
      fadeInDuration={200}
      style="border-radius: 0px; width: 510px">
      <div slot="content" class:mobile={false}>
        <div class="group-comments-container">
          {#if isCommentEditMode}
            <div class="add-comment-edit-mode-overlay" on:click={handleOverlayClick}></div>
          {/if}
          <div style="position: sticky">
            <ListCommentsHeader
              on:closed={() => {
                showModal = false;
              }}
              total={total}
              mobile={false} />
          </div>
          <div
            bind:this={commentOuterContainer}
            class="purple-scrollbar-thin comments-listing-container"
            class:focused={focused}
            style="{isFixed ? 'overflow-y: auto' : ''};">
            {#if group.show_comments}
              {#if total > 0}
                <Comments
                  bind:el={commentContainer}
                  customGroupStore={customGroupStore}
                  mobile={false}
                  viewStyle="detail-view" />
              {/if}
            {/if}
            {#if !isFixed}
              <div class="add-unfixed-comment-container">
                <div style="padding: 10px">
                  {#key addCommentKey}
                    <AddComment
                      bind:editMode={isCommentEditMode}
                      mobile={false}
                      customGroupStore={customGroupStore}
                      startFocused={true}
                      inlineStyling={true}
                      context={'list'}
                      commentContainerHeight={commentContainerHeight} />
                  {/key}
                </div>
              </div>
            {/if}
          </div>
          {#if isFixed}
            <div
              style="margin-top: 15px; margin-left: -32px; padding-left: 32px; padding-right: 39px; padding-bottom: 15px;"
              class="fixed-add-comment">
              <div class="fixed-add-comment__shadow"></div>
              {#key addCommentKey}
                <AddComment
                  bind:editMode={isCommentEditMode}
                  mobile={false}
                  customGroupStore={customGroupStore}
                  startFocused={true}
                  context={'list'} />
              {/key}
            </div>
          {/if}
        </div>
      </div>
    </Modal>
  </div>
{/if}
